/* import __COLOCATED_TEMPLATE__ from './detail-instructors.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { cached, tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { dropTask, restartableTask } from 'ember-concurrency';
import { hash } from 'rsvp';
import { TrackedAsyncData } from 'ember-async-data';
let DetailInstructorsComponent = (_class = class DetailInstructorsComponent extends Component {
  get ilmSessionData() {
    return new TrackedAsyncData(this.args.session.ilmSession);
  }
  get ilmInstructorsData() {
    return new TrackedAsyncData(this.ilmSession?.instructors);
  }
  get ilmInstructorGroupsData() {
    return new TrackedAsyncData(this.ilmSession?.instructorGroups);
  }
  get ilmSession() {
    return this.ilmSessionData.isResolved ? this.ilmSessionData.value : null;
  }
  get ilmInstructors() {
    return this.ilmInstructorsData.isResolved ? this.ilmInstructorsData.value : null;
  }
  get ilmInstructorGroups() {
    return this.ilmInstructorGroupsData.isResolved ? this.ilmInstructorGroupsData.value : null;
  }
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "currentUser", _descriptor, this);
    _initializerDefineProperty(this, "isManaging", _descriptor2, this);
    _initializerDefineProperty(this, "instructorGroupBuffer", _descriptor3, this);
    _initializerDefineProperty(this, "instructorBuffer", _descriptor4, this);
    _initializerDefineProperty(this, "availableInstructorGroups", _descriptor5, this);
    _defineProperty(this, "load", _buildTask(() => ({
      context: this,
      generator: function* () {
        const user = yield this.currentUser.getModel();
        const school = yield user.school;
        this.availableInstructorGroups = yield school.instructorGroups;
      }
    }), null, "load", "restartable"));
    _defineProperty(this, "manage", _buildTask(() => ({
      context: this,
      generator: function* () {
        const ilmSession = yield this.args.session.ilmSession;
        const {
          instructorGroups,
          instructors
        } = yield hash({
          instructorGroups: ilmSession.instructorGroups,
          instructors: ilmSession.instructors
        });
        this.instructorGroupBuffer = instructorGroups;
        this.instructorBuffer = instructors;
        this.isManaging = true;
      }
    }), null, "manage", "drop"));
    _defineProperty(this, "save", _buildTask(() => ({
      context: this,
      generator: function* () {
        const ilmSession = yield this.args.session.ilmSession;
        ilmSession.set('instructorGroups', this.instructorGroupBuffer);
        ilmSession.set('instructors', this.instructorBuffer);
        yield ilmSession.save();
        this.isManaging = false;
      }
    }), null, "save", "drop"));
    this.load.perform();
  }
  get instructorCount() {
    if (!this.ilmSession) {
      return 0;
    }
    return this.ilmSession.instructors.length;
  }
  get selectedIlmInstructors() {
    if (!this.ilmInstructors) {
      return [];
    }
    return this.ilmInstructors;
  }
  get selectedIlmInstructorGroups() {
    if (!this.ilmInstructorGroups) {
      return [];
    }
    return this.ilmInstructorGroups;
  }
  get instructorGroupCount() {
    if (!this.ilmSession) {
      return 0;
    }
    return this.ilmSession.instructorGroups.length;
  }
  cancel() {
    this.instructorGroupBuffer = [];
    this.instructorBuffer = [];
    this.isManaging = false;
  }
  addInstructorGroupToBuffer(instructorGroup) {
    this.instructorGroupBuffer = [...this.instructorGroupBuffer, instructorGroup];
  }
  removeInstructorGroupFromBuffer(instructorGroup) {
    this.instructorGroupBuffer = this.instructorGroupBuffer.filter(obj => obj.id !== instructorGroup.id);
  }
  addInstructorToBuffer(instructor) {
    this.instructorBuffer = [...this.instructorBuffer, instructor];
  }
  removeInstructorFromBuffer(instructor) {
    this.instructorBuffer = this.instructorBuffer.filter(obj => obj.id !== instructor.id);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isManaging", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "instructorGroupBuffer", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "instructorBuffer", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "availableInstructorGroups", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "ilmSessionData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "ilmSessionData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "ilmInstructorsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "ilmInstructorsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "ilmInstructorGroupsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "ilmInstructorGroupsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "cancel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addInstructorGroupToBuffer", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addInstructorGroupToBuffer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeInstructorGroupFromBuffer", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeInstructorGroupFromBuffer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addInstructorToBuffer", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addInstructorToBuffer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeInstructorFromBuffer", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeInstructorFromBuffer"), _class.prototype), _class);
export { DetailInstructorsComponent as default };